import { useLazyQuery, useMutation } from "@apollo/client";
import React, { useEffect, useRef, useState } from "react";
import { IoSettingsOutline } from "react-icons/io5";
import { useDispatch, useSelector } from "react-redux";
import { useRecoilState } from "recoil";
import pathState from "../../../../atoms/pathstate";
import { ClearSpecificForm } from "../../../../Store/FormDataReducer/FormFieldFunctions";
import {
  CreateVendorAccount,
  DELETE_Account_MUTATION,
  EDIT_VendorAccount,
  GetAccountDataByID,
  GetAccountRefrencesByID,
  GrtPreferenceByFormKey,
  LOCK_ACCOUNT,
  MERGE_ACCOUNT,
} from "../../../../Utils/AllPagesQuriesAndMutations";
import PortalFooter from "../../../Components/Reactportal/PortalFooter";
import Reactportal from "../../../Components/Reactportal/Reactportal";
import { checkFormErrors } from "../../../custom_hooks/useCheckFormError";
import useConcatenatedString from "../../../custom_hooks/useConcatenatedString";
import useFetchFormFields from "../../../custom_hooks/useFetchFormFields";
import { useGetPageData } from "../../../custom_hooks/useGetPageData";
import Button from "../../Button/Button";
import { Confirm } from "../../Confirmation/Confirm";
import { FormConfiguration } from "../../FormConfiguration/FormConfiguration";
import { handleFormReset, updateSingleField, updateValueForm } from "../../FormInputSectionComponent/formUtils";
import { useModalContext } from "../../Reactportal/ModalContext";
import { ErrorToast, SuccessToast, WarningToast } from "../../ToastComponent/RectHotToast";
import ".././FormComponent.scss";
import { data, DefaultConfiguration, VendorRemarksData } from "./AddVendorAccount.config.js";
import "./AddVendorAccount.scss";
import AddVendorAccountSection from "./AddVendorAccountSection/AddVendorAccountSection";
import VendorRemarks from "./AddVendorAccountSection/Remarks";
import UserPreference from "./UserPreferenceAndVehicleCategory/UserPreference";
import VehicleCategorySelection from "./UserPreferenceAndVehicleCategory/VehicleCategorySelection";
import ViewVendorFiles from "./ViewFiles";
import extractCustomFields from "../../../CommonFunction/extractCustomFields";
import processFormDataWithCustomFields from "../../../CommonFunction/processFormDataWithCustomFields";
import { AmountDetails, initialRef, TransactionTypeDetails } from "../ReferenceSection/Reference.config";
import { convertToISO, IsoToDateWithoutTime } from "../../../../CommonFunction/IsoDateTime";
import { ReferenceModal } from "../ReferenceSection/ReferenceModal";
import { prepareReferenceData } from "../../InvoceComponents/RelatedFunctions";
import useIsDisabled from "../../../custom_hooks/useIsDisabled";
import { AccountGroupData } from "../AddAccountGroup/AddAccountGroup.config";
import { GetTodaysDateINdmy } from "../../../../CommonFunction/GetTodaysDate";

const AddVendorAccount = ({
  show,
  TypeOfPortal,
  submitType,
  ParentPortalCloseFunction,
  setShow,
  ReferenceFieldName = [],
  ReferFormKey = "",
}) => {
  console.log(ReferenceFieldName, ReferFormKey, "ReferFormKeyReferFormKey")
  const { pushModal, popModal } = useModalContext();
  const ReferenceData = useSelector((store) => store.TableDataReducer.tableData);

  const modifiedTypeOfPortal = useConcatenatedString(TypeOfPortal, "Vendor Account");
  const Form_Key ="Vendor_Account";
  const fielddataRedux = useSelector((store) => store.UniqueTableReducer);
  const fielddata = fielddataRedux?.Vendor_Account?.Selected_Row || fielddataRedux?.Account_Vouchers?.Selected_Row || fielddataRedux?.Transaction_Checks?.Selected_Row;
  const [toggle, settoggle] = useState(show ? show : false);
  const [RefRows, setRefRows] = useState({ 1: {} });
  const [showUserPreference, setShowUserPreference] = useState(false);
  const [preferedVehicle, setPreferedVehicle] = useState([]);
  const [preferedFromCityLane, setPreferedFromCityLane] = useState([]);
  const [preferedToCityLane, setPreferedToCityLane] = useState([]);
  const [allFieldsData, setAllFieldsData] = useState();
  const [accountId, setAccountId] = useState("");
  const [showVehicleCategory, setShowCategory] = useState(false);
  const dispatch = useDispatch();
  const [formErrors, setFormErrors] = useState({});
  const [FormData, setFormdata] = useState({});
  const [showRemarkModal, setShowRemarkModal] = useState(false);
  const [ShowInfoModal, setShowInfoModal] = useState(false);
  const [RemarkFields, SetRemarkFields] = useState(VendorRemarksData["Is_Verified"]);
  const [isFirstLoad, setFirstLoad] = useState(false);
  const [Remark, setRemark] = useState({
    Verified_Remark: "",
    Not_Intrested_Remark: "",
  });
  console.log(FormData, "FormDataFormDataFormDataFormData")
  const [openRef, setOpenRef] = useState(false);
  const { fields } = useGetPageData();
  const formRef = useRef({});
  const [{ CurrentTitle }, setPaths] = useRecoilState(pathState);
  const [error, setError] = useState(false);
  const [selectedRows, setSelectedRows] = useState([]);
  const FormDataFromRedux = useSelector((store) => store?.FormDataReducer);
  const [openSetting, setOpenSetting] = useState(false);
  const [storeCustomFields, setStoreCustomFields] = useState([]);
  const [initialData, setInitialData] = useState({})
  const { isDisabled } = useIsDisabled({ TypeOfPortal, initial: initialData, current: FormData });

  //Q & M
  const {
    loading: getFormFieldsLoading,
    data: inputFields,
    getFormSectionAndFields,
  } = useFetchFormFields({ Form_Key: TypeOfPortal == "Merge" ? "Vendor_Merge" : "Vendor_Account" });
  const [GetDefaultAccountGroup] = useLazyQuery(AccountGroupData)
  const [createVendorAccount, { loading: createVendorAccountLoading }] = useMutation(CreateVendorAccount);
  const [GetRefByID] = useLazyQuery(GetAccountRefrencesByID, {
    fetchPolicy: "network-only",
  });
  const [GetDataByID, { loading: GetDataByIDLoader }] = useLazyQuery(GetAccountDataByID, {
    fetchPolicy: "network-only",
  });
  const [MergingData, { loading: MergeEmtAccountLoading }] = useMutation(MERGE_ACCOUNT, {
    fetchPolicy: "network-only",

  });
  const [editVendorAccount, { loading: editVendorAccountLoading }] = useMutation(EDIT_VendorAccount(fields));

  const [deleteVendorAccount, { loading: deleteVendorAccountLoading }] = useMutation(DELETE_Account_MUTATION);

  const [lockVendorAccount, { loading: lockVendorAccountLoading }] = useMutation(LOCK_ACCOUNT);

  const [getDataByKey, { loading: userPreferenceLoading }] = useLazyQuery(GrtPreferenceByFormKey, {
    variables: {
      Form_Key: Form_Key,
    },
    fetchPolicy: "network-only",
  });

  const VendorAccountLoadingState =
    getFormFieldsLoading ||
    deleteVendorAccountLoading ||
    editVendorAccountLoading ||
    lockVendorAccountLoading ||
    createVendorAccountLoading ||
    GetDataByIDLoader ||
    userPreferenceLoading;

  const HandleError = (data) => {
    setError(data);
  };
  const OpenReference = () => {
    setOpenRef(true);
  };
 

  const HanldeChangeonForm = (values) => {
    setFormdata(prev => {
      const next = { ...prev, ...values };

      if (!isFirstLoad) {
        setInitialData(next)
      }
      return next
    })
  };


  useEffect(() => {
    if (isFirstLoad) {
      setShowRemarkModal(FormData?.Not_Intrested);
      SetRemarkFields(VendorRemarksData["Not_Intrested"]);
    }
  }, [FormData?.Not_Intrested]);

  useEffect(() => {
    if (isFirstLoad) {
      setShowRemarkModal(FormData?.Is_Verified);
      SetRemarkFields(VendorRemarksData["Is_Verified"]);
    }
  }, [FormData?.Is_Verified]);

  const handleErrorsChange = (newErrors) => {
    setFormErrors((currentErrors) => ({
      ...currentErrors,
      ...newErrors,
    }));
  };

  //to check errors and throw the error submit will not
  const Validate_handleSubmit = (submit) => {
    const Error = checkFormErrors(formErrors);
    if (!Error) {
      submit();
    }
  };

  useEffect(() => {
    pushModal(Form_Key);
    return () => {
      popModal(Form_Key);
    };
  }, []);

  const getDefaultValues = async () => {

    GetDefaultAccountGroup({
      variables: {
        keyword: "Sundary Creditor"
      }
    }).then(({ data }) => {
      console.log(data)
      let group = data?.searchAccountGroups[0]

      updateValueForm(formRef, {
        Account_Group: group?.Search_Value,
        Balance_Method: true,
        Account_Type:"Vendor Account",
        Opening_Balance : 0,
        Credit_Or_Debit : "Db",

      });
      dispatch({
        type: "StoreMasterData",
        payload: {
          formkey: Form_Key,
          data: {
            Account_Group: group
          },
        },
      });
    })



  };

  useEffect(() => {
    getFormSectionAndFields().then(() => {
      if (TypeOfPortal !== "Add" && TypeOfPortal !== "Delete" && modifiedTypeOfPortal !== "Add Vendor Account") {
        let id = fielddata?.__typename === "AccountBalanceSchema" ? fielddata?.Account_Type_Id : fielddata?._id;
        GetDataByID({
          variables: {
            id: id,
          },
        }).then(({ data }) => {
          let accountClone = { ...data?.Account };
          accountClone.Balance_Method = data?.Account?.Balance_Method === "Bill By Bill" ? true : false;

          setRemark({
            Verified_Remark: accountClone?.Verified_Remark,
            Not_Intrested_Remark: accountClone?.Not_Intrested_Remark,
          });
          setPreferedFromCityLane(accountClone?.LaneData?.From_Location);
          setPreferedToCityLane(accountClone?.LaneData?.To_Location);

          setPreferedVehicle(accountClone?.VehicleTypeData?.[0]?.Vehicle_Category_Management);
          setAccountId(accountClone._id);

          dispatch({
            type: "StoreMasterData",
            payload: {
              formkey: Form_Key,
              data: {
                Account_Group: accountClone?.Account_Groups,
                Account_Manager: accountClone.Account_ManagerData,
              },
            },
          });
          if (accountClone && accountClone.Account_Groups) {
            accountClone.Account_Group = accountClone?.Account_Groups?.Account_Group;
          }
          if (accountClone && accountClone.Account_ManagerData) {
            accountClone.Account_Manager = accountClone.Account_ManagerData.Full_Name;
          }
          if (accountClone?.customFieldData && typeof accountClone.customFieldData === "object") {
            Object.entries(accountClone.customFieldData).forEach(([key, value]) => {
              accountClone[key] = value ?? ""; // Assign value or empty string if undefined/null
            });
          }
          setAllFieldsData(accountClone);
          updateValueForm(formRef, accountClone);

        });
        GetRefByID({
          variables: {
            Account_Id: id,
          },
        }).then(({ data }) => {
          if (data?.getAccountRefrencesByID?.length) {

            let updatedTransRef = {

            };
            data?.getAccountRefrencesByID?.map((el) => {
              let InitialRef = [
                ...initialRef.slice(0, -1),
                AmountDetails,
                TransactionTypeDetails,
                initialRef[initialRef.length - 1],
              ];
              console.log(InitialRef, "InitialRef")
              let singleRef = InitialRef.map((item) => {
                if (item.name === "Particular") {
                  item = { ...item, NewRef_Id: el["NewRef_Id"] };
                }
                if (item.name === "RefDate") {
                  return { ...item, value: IsoToDateWithoutTime(el[item.name]) };
                }
                return { ...item, value: el[item.name] };
              });
              updatedTransRef = {
                ...updatedTransRef,
                [Math.random() * 10]: singleRef,
              };
            });
            console.log(updatedTransRef);
            setRefRows({
              [1]: updatedTransRef,
            });
          }
        });
      } else {
        getDefaultValues();

      }
    });
  }, [fielddata]);
  useEffect(() => {
    let total = FormData?.Opening_Balance;

    if (
      total &&
      (FormData?.Balance_Method === "Bill By Bill" || FormData?.Balance_Method === true) &&
      FormData?.Credit_Or_Debit &&
      isFirstLoad
    ) {
      let InitialRef = [
        ...initialRef.slice(0, -1),
        AmountDetails,
        TransactionTypeDetails,
        initialRef[initialRef.length - 1],
      ];

      let singleRef = InitialRef.map((item) => {

        if (item.name === "Particular") {
          return { ...item, value: FormData?.Invoice_No || "" };
        }
        if (item.name === "Type") {
          return { ...item, value: `New Reference` };
        }
        if (item.name === "Amount") {
          return { ...item, value: total };
        }
        if (item.name === "TransactionType") {
          console.log(FormData?.Credit_Or_Debit, FormData);
          return {
            ...item,
            value: FormData?.Credit_Or_Debit == "Cr" ? "Credit" : FormData?.Credit_Or_Debit == "Db" ? "Debit" : "",
          };
        }
          if (item.name === "RefDate") {
                  return { ...item, value: GetTodaysDateINdmy() };
                }
        return item;
      });

      let updatedTransRef = {
        [Math.random() * 10]: singleRef,
      };
      console.log(updatedTransRef, "updatedTransRefupdatedTransRef");
      setRefRows({
        [1]: updatedTransRef,
      });
    }
  }, [FormData?.Opening_Balance, FormData?.Credit_Or_Debit, FormData?.Balance_Method]);

  useEffect(() => {
    dispatch({ type: "tableData", payload: RefRows });
  }, [RefRows]);
  useEffect(() => {
    setSelectedRows(fielddataRedux?.Vendor_Account?.Selected_Rows);
  }, [fielddataRedux]);

  formRef.current.OpenReviewModal = (fieldName) => {
    setShowInfoModal(true);
    SetRemarkFields(VendorRemarksData[fieldName.name] || fieldName);
  };

  useEffect(() => {
    if (inputFields && inputFields?.length > 0) {
      const fields = extractCustomFields(inputFields);
      setStoreCustomFields(fields);
    }
  }, [inputFields]);

  const submit = async (close) => {
    let newFormData = { ...FormData, ...Remark };
    let data = processFormDataWithCustomFields(newFormData, storeCustomFields);
    if (data && data.Aadhar_Number && typeof data.Aadhar_Number !== "number" && data.Aadhar_Number?.includes("-")) {
      data.Aadhar_Number = data?.Aadhar_Number?.replace(/[^0-9]/g, "");
    }

    data.Account_Manager = FormDataFromRedux?.MasterData[Form_Key]?.Account_Manager?._id;
    data.Account_Group = FormDataFromRedux?.MasterData[Form_Key]?.Account_Group?._id;
    data.Default_TDS_Section = FormDataFromRedux?.MasterData[Form_Key]?.Default_TDS_Section?._id;

    let Name = ReferenceFieldName[0]?.name;
    let rowId = ReferenceFieldName[0]?.rowId;
    delete data.accountgroups;

    let References = prepareReferenceData(ReferenceData);
    console.log(ReferenceData, References, "ReferencesReferences")
    if (TypeOfPortal === "Edit" || modifiedTypeOfPortal === "Edit Vendor Account") {
      let adhar = data.Aadhar_Number;
      if (data && data.Aadhar_Number && typeof data.Aadhar_Number !== "number" && data.Aadhar_Number.includes("-")) {
        adhar = data.Aadhar_Number.replace(/[^0-9]/g, "");
      }
      data = {
        ...data,
        Account_Type: data.Account_Type || "Vendor Account",
        Aadhar_Number: adhar,
        UserId: allFieldsData?.UserId,
      };
      data.Balance_Method = data.Balance_Method ? "Bill By Bill" : "Balance only";
      await editVendorAccount({
        variables: {
          id: fielddata._id,
          userInput: data,
          ...((FormData?.Balance_Method === "Bill By Bill" || FormData?.Balance_Method === true) && { ReferenceInput: References, }),

        },
      })
        .then((res) => {
          let data = rowId ? { [rowId]: { [Name]: res?.data?.editAccount } } : { [Name]: res?.data?.editAccount };
          dispatch({
            type: "StoreMasterData",
            payload: {
              formkey: ReferFormKey,
              data,
            },
          });
          dispatch({ type: "Refetch", payload: true });
          SuccessToast("Vendor Edited Sucessfully..!");
          Closeformfunction();
        })
        .catch((err) => {
          ErrorToast(err.message);
        });
    } else if (TypeOfPortal === "Lock" || TypeOfPortal === "Unlock") {
      const ArrayOfID = selectedRows.map((obj) => obj._id);

      await lockVendorAccount({
        variables: {
          idsToUpdate: ArrayOfID,
          Is_Lock: TypeOfPortal === "Lock" ? true : false,
        },
      })
        .then((res) => {
          SuccessToast("Locked SucessFully");
          settoggle(false);
          dispatch({ type: "Refetch", payload: true });
        })
        .catch((err) => ErrorToast(err.message));
    } else if (TypeOfPortal === "Delete" || modifiedTypeOfPortal === "Delete Vendor Account") {
      const ArrayOfID = selectedRows.map((obj) => obj._id);
      await deleteVendorAccount({
        variables: { idsToDelete: ArrayOfID },
      })
        .then((res) => {
          if (CurrentTitle === Form_Key) {
            dispatch({ type: "Refetch", payload: true });
          }
          SuccessToast("Account Deleted");
          settoggle(false);
        })
        .catch((err) => {
          ErrorToast(err.message);
        });
    }
    else if (TypeOfPortal === "Merge") {
      newFormData.existingId = fielddata?._id;
      newFormData.newId = FormDataFromRedux?.MasterData?.[Form_Key]?.replace_with?._id;
      console.log(FormDataFromRedux?.MasterData)
      MergingData({
        variables: {
          existingId: fielddata?._id,
          newId: FormDataFromRedux?.MasterData?.[Form_Key]?.replace_with?._id
        }
      }).then((res) => {
        SuccessToast("Account Merged Successfuly")
        dispatch({ type: "Refetch", payload: true });

        Closeformfunction();
      }).catch((error) => {
        ErrorToast(error.message)
      })
    }
    else {
      //This return is responsible for not opening the add vendor account modal
      data = { ...data, Account_Type: "Vendor Account" };
      data.Balance_Method = data?.Balance_Method ? "Bill By Bill" : "Balance only";
      await createVendorAccount({
        variables: {
          input: data,
          ...((FormData?.Balance_Method === "Bill By Bill" || FormData?.Balance_Method === true) && { ReferenceInput: References, }),
        },
      })
        .then(async (res) => {
          let data = rowId ? { [rowId]: { [Name]: res?.data?.createAccount } } : { [Name]: res?.data?.createAccount };
          dispatch({
            type: "StoreMasterData",
            payload: {
              formkey: ReferFormKey,
              data,
            },
          });
          SuccessToast("Account Created Successfully...!");
          console.log(CurrentTitle, Form_Key);
          if (CurrentTitle === Form_Key) {
            dispatch({ type: "Refetch", payload: true });
          }
          handleFormReset(formRef);
          getDefaultValues()
          if (close === "Close") {
            Closeformfunction();
          }
          // setFormdata({});
          // dispatch({ type: "ClearData", payload: { data: {} } });
        })
        .catch((err) => {
          // settoggle(toggle);
          ErrorToast(err.message);
        });
    }
    //Closeformfunction();
  };

  const Closeformfunction = () => {
    ParentPortalCloseFunction();
    settoggle(false);
    ClearSpecificForm(dispatch, Form_Key);
    if (setShow) {
      setShow(false);
    }
  };

  const SaveAndCloseForAdd = () => {
    submit("Close");
  };

  const HandleRemarkChange = (e) => {
    setRemark((prev) => {
      return { ...prev, [e.target.name]: e.target.value };
    });
  };
  // console.log(FormData);
  if (TypeOfPortal === "Lock" || TypeOfPortal === "Unlock" || TypeOfPortal === "Delete") {
    return (
      <>
        <Confirm
          submitType={`Confirm ${TypeOfPortal}`}
          submit={submit}
          settoggle={settoggle}
          toggle={toggle}
          loadingState={VendorAccountLoadingState}
          message={`Are You Sure You Want to ${TypeOfPortal} this Record?`}
        />
      </>
    );
  }

  const footerContent = (
    <PortalFooter
      renderContent={() => (
        <>
          {FormData?.Balance_Method === "Bill By Bill" || FormData?.Balance_Method === true ? (
            <>
              <Button action={() => OpenReference()} name="modalbutton" text="Reference" />
            </>
          ) : (
            <></>
          )}
          {TypeOfPortal !== "Add" && TypeOfPortal !== "Merge" ? (
            <>
              <Button action={() => setShowUserPreference(true)} name="modalbutton" text="Preferred Lane" />
              <Button action={() => setShowCategory(true)} name="modalbutton" text="Preferred Vehicle Type" />
            </>
          ) : (
            <></>
          )}
        </>
      )}
      disabled={isDisabled}
      submitform={() => {
        // handleFormReset(formRef);
        Validate_handleSubmit(submit);
      }}
      submitType={submitType}
      SaveAndClose={
        TypeOfPortal === "Add"
          ? () => {
            Validate_handleSubmit(SaveAndCloseForAdd);
          }
          : () => {
            Validate_handleSubmit(submit);
          }
      }
      handleformclose={() => {
        Closeformfunction();
        settoggle(!toggle);
      }}
      error={error}
      loadingState={VendorAccountLoadingState}
      Form_key={Form_Key}
      TypeOfPortal={TypeOfPortal}
    />
  );

  const HandleSettingClick = () => {
    setOpenSetting(true);
  };

  return (
    <>
      <div>
        <Reactportal
          FoooterContent={footerContent}
          open={toggle}
          onClose={Closeformfunction}
          TypeOfPortal={modifiedTypeOfPortal}
          TypeOfId={`Account Id :${FormData?.Unique_Id}`}
          id={FormData?.Unique_Id}
          Form_Key={Form_Key}
          AdditionalContent={() => {
            if (TypeOfPortal !== "Merge") {

              return (
                <span onClick={HandleSettingClick} className="settingIcon">
                  <IoSettingsOutline className="settingIcon" />
                </span>
              );
            }
          }}
        >
          <div className="VendorAccountSection">
            {VendorAccountLoadingState && <div className="loader-line-div" />}
            <div className="formContainer">
              {inputFields && inputFields?.length > 0 ? (
                inputFields.map((e) => (
                  <React.Fragment key={e.id}>
                    <AddVendorAccountSection
                      inputfields={e.fields}
                      e={e}
                      Type={e.name}
                      TypeOfPortal={TypeOfPortal}
                      configData={data}
                      HandleError={HandleError}
                      accountId={accountId}
                      handleErrorsChange={handleErrorsChange}
                      HanldeChangeonForm={HanldeChangeonForm}
                      ValidationName={e?.ValidationName}
                      formkey={Form_Key}
                      formRef={formRef}
                      setFirstLoad={setFirstLoad}
                      isFirstLoad={isFirstLoad}
                    />
                  </React.Fragment>
                ))
              ) : !getFormFieldsLoading && (inputFields?.message || inputFields?.length === 0) ? (
                <p>No form fields available.</p>
              ) : null}

              {showUserPreference && (
                <UserPreference
                  show={true}
                  TypeOfPortal={TypeOfPortal}
                  vehicleIds={preferedVehicle}
                  formCities={preferedFromCityLane}
                  toCities={preferedToCityLane}
                  setPreferedVehicle={(val) => setPreferedVehicle(val)}
                  setShowModal={() => setShowUserPreference(false)}
                  setPreferedFromCityLane={(val) => setPreferedFromCityLane(val)}
                  setPreferedToCityLane={(val) => setPreferedToCityLane(val)}
                  allFieldsData={allFieldsData}
                />
              )}

              {showVehicleCategory && (
                <VehicleCategorySelection
                  show={true}
                  setShowModal={() => setShowCategory(false)}
                  vehicleIds={preferedVehicle}
                  setPreferedVehicle={(val) => setPreferedVehicle(val)}
                  allFieldsData={allFieldsData}
                />
              )}
            </div>
          </div>
        </Reactportal>
      </div>
      {openSetting && (
        <FormConfiguration
          show={openSetting}
          ParentClosingFunction={setOpenSetting}
          config={DefaultConfiguration}
          HanldeChangeonForm={HanldeChangeonForm}
          formRef={formRef}
          setFirstLoad={setFirstLoad}
          allFieldsData={allFieldsData}
          getFormSectionAndFields={getFormSectionAndFields}
          ToGetDefaultValues={() => {
            getDefaultValues();
          }}
          formKey={Form_Key}
          forFormValues={FormData}
          preference={false}
        />
      )}
      {showRemarkModal && (
        <VendorRemarks
          show={showRemarkModal}
          onhandleFormikChange={HandleRemarkChange}
          field={RemarkFields}
          values={Remark}
          setShowModal={() => setShowRemarkModal(false)}
        />
      )}
      {ShowInfoModal && (
        <ViewVendorFiles
          Values={formRef?.current?.Controls?.values}
          show={true}
          TypeOfPortal={TypeOfPortal}
          setShowModal={() => setShowInfoModal(false)}
          accountId={fielddata?._id}
          Remark={Remark}
          Type={
            RemarkFields.name === "Is_Pan_Verified"
              ? "PAN"
              : RemarkFields.name === "Is_Gst_Verified"
                ? "GST"
                : RemarkFields.name === "Is_Aadhar_Verified"
                  ? "Aadhaar"
                  : RemarkFields.name === "Verified_Remark"
                    ? "verified"
                    : RemarkFields.name === "Not_Intrested_Remark"
                      ? "Not_Intrested"
                      : "Bank"
          }
        />
      )}
      {openRef && (
        <ReferenceModal
          show={openRef}
          setModalToggle={() => setOpenRef(false)}
          transactionId={1}
          Amount={FormData?.Opening_Balance}
          Account_ID={""}
          Transaction_Type={
            FormData?.Credit_Or_Debit == "Cr" ? "Credit" : FormData?.Credit_Or_Debit == "Db" ? "Debit" : ""
          }
        />
      )}
    </>
  );
};

export default AddVendorAccount;
